<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class="d-flex flex-row justify-content-between pb-4">
        <div class="d-flex flex-row" style="align-items: self-end;width: 50%;">
            <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
                #openFile name="openFile" accept="image/png, image/jpg, image/jpeg" />
            <img class="admin_picture"
                [src]="!techSupportModel.profilePictureUrl ? imagePath:techSupportModel.profilePictureUrl "
                alt="profile-picture">
            <div class="picture-edit">
                <div (click)="openAddImage()" class="d-flex flex-row">
                    <i class="pi pi-pencil"></i>
                    <p class="m-0">{{ 'PERSONAL_PROFILE.CHANGE_PICTURE' | translate }}</p>
                </div>
                <label class="pictureError" *ngIf="pictureIsWrongFormat">{{ 'VENUES.PICTURE_IS_WRONG_FORMAT'
                    |translate}}</label>
            </div>
        </div>

        <div style="width: 50%; ">
            <label style="margin-top: 0px;" class="title_label">{{ 'EMAIL' | translate }}
                <i *ngIf="!enableEdit" class="pi pi-pencil float-end"></i>
                <i *ngIf="errorModel!=null && errorModel['Email']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['Email']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" disabled="{{enableEdit}}" class="input_text_field" [(ngModel)]="techSupportModel.email">
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div style="width: 50%; ">
            <label style="margin-top: 0px;" class="title_label">{{ 'FIRST NAME' | translate }}
                <i class="pi pi-pencil float-end"></i>
                <i *ngIf="errorModel!=null && errorModel['FirstName']!=null"
                    class="pi pi-exclamation-circle float-end me-1 error_color"
                    pTooltip="{{errorModel['FirstName']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" class="input_text_field" [(ngModel)]="techSupportModel.firstName">
        </div>
        <div style="width: 50%; ">
            <label style="margin-top: 0px;" class="title_label">{{ 'LAST NAME' | translate }}
                <i class="pi pi-pencil float-end"></i>
                <i *ngIf="errorModel!=null && errorModel['LastName']!=null"
                class="pi pi-exclamation-circle float-end me-1 error_color"
                pTooltip="{{errorModel['LastName']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" class="input_text_field" [(ngModel)]="techSupportModel.lastName">
        </div>
        <div style="width: 50%; ">
            <label style="margin-top: 0px;" class="title_label">{{ 'BIRTHDAY' | translate }}
                <i class="pi pi-pencil float-end"></i>
                <i *ngIf="errorModel!=null && errorModel['DateOfBirth']!=null"
                class="pi pi-exclamation-circle float-end me-1 error_color"
                pTooltip="{{errorModel['DateOfBirth']|translate}}" tooltipPosition="top"></i>
            </label>
            <p-calendar [(ngModel)]="techSupportModel.dateOfBirth" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
        </div>
        <div style="width: 50%; ">
            <label style="margin-top: 0px;" class="title_label">{{ 'PHONE' | translate }}
                <i class="pi pi-pencil float-end"></i>
                <i *ngIf="errorModel!=null && errorModel['Phone']!=null"
                class="pi pi-exclamation-circle float-end me-1 error_color"
                pTooltip="{{errorModel['Phone']|translate}}" tooltipPosition="top"></i>
            </label>
            <input type="text" class="input_text_field" [(ngModel)]="techSupportModel.phone">
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <button *ngIf="!enableEdit" class="btn_in_color" (click)="addsuperadmin(techSupportModel)">{{ 'SAVE_CHANGES' |
            translate}}</button>
        <button *ngIf="enableEdit" class="btn_in_color" (click)="updatesuperadmin(techSupportModel)">{{ 'SAVE_CHANGES' |
            translate}}</button>
        <button class="btn_without_color" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
</div>